export const APP_SET_LOCALE = 'APP_SET_LOCALE';
export const APP_RESET_PAGEDATA = 'APP_RESET_PAGEDATA';
export const APP_SET_PAGEDATA = 'APP_SET_PAGEDATA';
export const APP_UPDATE_DATA = 'APP_UPDATE_DATA';

export const appSetLocale = payload => ({ type: APP_SET_LOCALE, payload });
export const appResetPageData = () => ({ type: APP_RESET_PAGEDATA });
export const appSetPageData = payload => ({ type: APP_SET_PAGEDATA, payload });
export const appUpdateData = (key, data) => ({ type: APP_UPDATE_DATA, key, data });
